import { cn } from '@/utils/cn'

export interface ContainerProps {
  children: HTMLElement | HTMLElement[]
  className?: string
  size?: 'sm' | 'md' | 'lg' | 'full'
}

export function Container({
  children,
  className,
  size = 'lg',
}: ContainerProps): HTMLElement {
  const sizes = {
    sm: 'max-w-3xl',
    md: 'max-w-5xl',
    lg: 'max-w-7xl',
    full: 'max-w-full',
  }

  const container = document.createElement('div')
  container.className = cn('mx-auto px-4 sm:px-6 lg:px-8', sizes[size], className)

  if (Array.isArray(children)) {
    children.forEach(child => container.appendChild(child))
  } else {
    container.appendChild(children)
  }

  return container
}
